/*
 * @Author: tanyaohua
 * @Date: 2020-01-14 17:13:40
 * @Description: 评论详情弹框中的信息
 */

'use strict';

angular.module('newsPaperInfoModel', []).controller('newsPaperInfoCtrl', [
    '$scope',
    '$filter',
    '$modalInstance',
    'getRemarkDetail',
    'trsHttpService',
    'initVersionService',
    function($scope, $filter, $modalInstance, getRemarkDetail, trsHttpService, initVersionService) {
        initData();
        initStatus();

        /**
         * [initData description]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.params = {
                GUID: '',
            };
            $scope.data = {
                needItems: {},
                items: [],
            };
        }

        /**
         * [initData description]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            getRemarkInfo();
        }

        /**
         * [beforeGetInfo description]在发起请求之前处理参数
         *
         * @return  {[type]}  [return description]
         */
        function beforeGetInfo() {
            $scope.data.needItems = getRemarkDetail;
            $scope.params.GUID = getRemarkDetail.zb_guid;
        }

        /**
         * [getRemarkInfo description]获取报评的详情接口
         *
         * @return  {[type]}  [return description]
         */
        function getRemarkInfo() {
            beforeGetInfo();
            var params = {
                guid: $scope.params.GUID,
            };
            $scope.loadingPromise = trsHttpService.httpServer('/paperreview/paperReviewLog/findByGuid', params, 'post').then(function(data) {
                $scope.data.items = data.datas;
                $scope.data.items = initVersionService.getDayContent($scope.data.items, 'push');
            });
        }

        /**
         * [close description]关闭弹窗
         *
         * @return  {[type]}  [return description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [fromCharCode description]将数字转换成对应的字母等级
         *
         * @param   {[String]}  data  [data description]字符串
         *
         * @return  {[type]}        [return description]字母
         */
        $scope.fromCharCode = function(data) {
            return String.fromCharCode(64 + parseInt(data));
        };
    },
]);
